import * as React from "react";
import { Alert, AlertDescription, Button, Text } from "@zapier/design-system";
import styles from "./WarningAlert.module.css";

export interface WarningAlertProps {
  isOpen: boolean;
  title: string;
  message?: string;
  primaryButtonText?: string;
  secondaryButtonText?: string;
  status?: "warning" | "error" | "info";
  onPrimaryAction: () => void;
  onSecondaryAction: () => void;
  isPrimaryLoading?: boolean;
}

export const WarningAlert: React.FC<WarningAlertProps> = ({
  isOpen,
  title,
  message,
  primaryButtonText = "Confirm",
  secondaryButtonText = "Cancel",
  status = "warning",
  onPrimaryAction,
  onSecondaryAction,
  isPrimaryLoading = false,
}) => {
  if (!isOpen) return null;

  return (
    <div className={styles.alertWrapper}>
      <Alert
        title={<Text type="Body3Multiline">{title}</Text>}
        status={status}
        onDismiss={onSecondaryAction}
      >
        {message && (
          <AlertDescription>
            <Text type="Body1Multiline">{message}</Text>
          </AlertDescription>
        )}
        <div className={styles.footerContent}>
          <div className={styles.secondaryButton}>
            <Button
              variant="tertiary"
              size="small"
              onPress={onSecondaryAction}
              isDisabled={isPrimaryLoading}
            >
              {secondaryButtonText}
            </Button>
          </div>
          <Button
            variant="primary"
            size="small"
            onPress={onPrimaryAction}
            isDisabled={isPrimaryLoading}
            isPending={isPrimaryLoading}
          >
            {primaryButtonText}
          </Button>
        </div>
      </Alert>
    </div>
  );
};
